export enum HeadlineLevel {
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
}
